import clsx from 'clsx';
import { PoweredByCuddles } from 'components/Cuddles/PoweredBy/PoweredByCuddles';
import React from 'react';

import classes from './RightColumn.module.scss';

interface RightColumnProps {
    footer?: React.ReactNode;
    poweredByCuddles?: boolean;
    children?: React.ReactNode;
    className?: string;
    contentClassName?: string;
    alignContentVertically?: boolean;
    footerContentClassName?: string;
}

export const RightColumn: React.FC<RightColumnProps> = props => {
    return (
        <div className={clsx(classes.root, props.className)}>
            <div
                className={clsx('container', classes.content, props.contentClassName, {
                    'flex flex-col items-center justify-center': props.alignContentVertically
                })}
            >
                {props.children}
            </div>

            {props.footer && (
                <div className={classes.footer}>
                    <div
                        className={clsx(
                            'container',
                            classes.footerContent,
                            props.footerContentClassName
                        )}
                    >
                        {props.poweredByCuddles && (
                            <div className="mb-5 hide-on-desktop text-center">
                                <PoweredByCuddles />
                            </div>
                        )}

                        {props.footer}
                    </div>
                </div>
            )}
        </div>
    );
};
